import React, { Component, Fragment } from "react";
import { debounce } from "lodash";
import {
  Button,
  Col,
  Input,
  Select,
  Row,
  Table,
  Tooltip,
  message,
  Avatar,
  Form,
} from "antd";
import { EditOutlined, PlusOutlined, SearchOutlined } from "@ant-design/icons";
import { Constants } from "../scripts/settings";
import API from "../scripts/api";
import Resources from "../scripts/resources";
import PaginationInfo from "../components/PaginationInfo";
import { connect } from "react-redux";
import { SetRoute } from "../scripts/action";
import DownloadAppForm from "../forms/DownloadAppForm";

class AppDownloadManagement extends Component {
  constructor() {
    super();

    this.state = {
      data: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: Constants.pageSize,
        size: "small",
      },
      detail: { app_last_version: null, app_update: null },
      formValue: {},
      versionLoading: false,
    };

    this.formRef = React.createRef();
    this.formRef2 = React.createRef();

    this.handleSearch = debounce(this.handleSearch, 1000);
  }

  fetch = async (params = {}) => {
    this.setState({ loading: true, versionLoading: true });
    params.q = this.state.filterSearch;
    try {
      const result = await API.downloadApp.list(params);

      this.setState({
        data: result,
        pagination: {
          ...this.state.pagination,
          ...{
            current: result.current_page,
            pageSize: result.per_page,
            total: result.total,
          },
        },
      });
    } catch (error) {
      this.setState({ loading: false });
      console.log(error);
    }
    try {
      const { app_last_version, app_update } =
        await API.downloadApp.detail.list();

      this.formRef2.current.setFieldsValue({
        app_last_version,
        app_update,
      });

      this.setState({
        detail: { app_last_version, app_update },
        loading: false,
        versionLoading: false,
      });
    } catch (error) {
      this.setState({ loading: false });
      console.log(error);
    }
  };

  showForm = (tag = {}) => {
    this.setState({ visibleForm: true, selected: tag });

    setTimeout(() => {
      this.formRef.current.handleDidMount(tag);
    }, 0);
  };

  hideForm = () => {
    this.setState({ visibleForm: false });
    this.formRef.current.handleWillUnmount();
  };

  handleSearch = (value) => {
    this.setState({ filterSearch: value });

    setTimeout(() => {
      this.fetch({ page: 1 });
    }, 0);
  };

  handleSubmit = (values, id) => {
    const action = this.state.selected.id
      ? API.downloadApp.update
      : API.downloadApp.add;

    this.setState({ submitting: true });

    if (action === API.downloadApp.update) {
      values.append("id", id);
    }

    action(values)
      .then((result) => {
        this.setState({ submitting: false });
        this.hideForm();
        this.fetch({ page: this.state.pagination.current });
      })
      .catch(() => {
        this.setState({ submitting: false });
        this.hideForm();
        this.fetch({ page: this.state.pagination.current });
      });
  };

  handleFinishVersion = async (values) => {
    console.log("Success:", values);
    this.setState({ versionLoading: true });

    try {
      const res = await API.downloadApp.detail.save(values);
      console.log(res);
      message.success("با موفقیت ثبت شد");
      this.setState({ versionLoading: false });
    } catch (error) {
      message.success("با موفقیت ثبت شد");
      this.setState({ versionLoading: false });
      console.log(error);
    }
  };

  componentDidMount() {
    const { onSetRoute, routeName, parentName } = this.props;

    onSetRoute({ openKey: parentName, selectedKey: routeName });

    this.fetch({ page: 1 });
  }

  render() {
    const {
      data,
      loading,
      pagination,
      submitting,
      visibleForm,
      detail,
      versionLoading,
    } = this.state;

    console.log("DDetail");
    console.log(detail);

    const columns = [
      {
        title: Resources.logo,
        dataIndex: "logo",
        className: "col-center",
        render: (val) => (
          <Tooltip
            title={
              <Avatar
                src={`https://api.aras.market/${val}`}
                shape="square"
                size={200}
              />
            }
          >
            <Avatar
              src={`https://api.aras.market/${val}`}
              shape="square"
              size="small"
            />
          </Tooltip>
        ),
      },
      {
        title: Resources.url,
        dataIndex: "url",
      },
      {
        title: Resources.action,
        dataIndex: "id",
        className: "col-center",
        width: "120px",
        render: (val, record) => (
          <Fragment>
            <Tooltip title={Resources.edit}>
              <Button
                type="link"
                icon={<EditOutlined />}
                onClick={() => this.showForm(record)}
              />
            </Tooltip>
          </Fragment>
        ),
      },
    ];

    return (
      <Fragment>
        <br />
        <Row gutter={24} style={{ marginBottom: 16 }}>
          <Col xs={24} md={4}>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => this.showForm()}
              block
            >
              {Resources.add}
            </Button>
          </Col>

          <Col xs={24} md={{ span: 6, offset: 14 }}>
            <Tooltip title={Resources.search}>
              <Input
                type="text"
                prefix={<SearchOutlined />}
                placeholder={Resources.search}
                onChange={({ target: { value } }) => this.handleSearch(value)}
                allowClear
              />
            </Tooltip>
          </Col>
        </Row>

        <div className="ant-content">
          <Row>
            <Col xs={24}>
              <Form
                name="basic"
                onFinish={this.handleFinishVersion}
                autoComplete="off"
                ref={this.formRef2}
              >
                <Row gutter={10}>
                  <Col xs={24} sm={8}>
                    تنظیم ورژن درحال استفاده :
                  </Col>
                  <Col xs={24} sm={6}>
                    <Form.Item
                      defaultValue={detail.app_last_version}
                      label="آخرین ورژن"
                      name="app_last_version"
                    >
                      <Input style={{ width: "100%" }} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={6}>
                    <Form.Item label="آخرین ورژن" name="app_update">
                      <Select style={{ width: "100%" }}>
                        <Select.Option value="2">اجباری</Select.Option>
                        <Select.Option value="1">اختیاری</Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={4}>
                    <Button
                      block
                      type="primary"
                      htmlType="submit"
                      // loading={versionLoading}
                    >
                      ثبت
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Col>
            <Col xs={24}>
              <Table
                columns={columns}
                dataSource={data}
                loading={loading}
                onChange={this.handleTableChange}
                pagination={pagination}
                size="small"
                rowKey="id"
                scroll={{ x: 600 }}
              />
              {!!pagination.total && (
                <PaginationInfo
                  current={pagination.current}
                  pageSize={pagination.pageSize}
                  total={pagination.total}
                  style={{ bottom: 0, right: 0 }}
                />
              )}
              <DownloadAppForm
                ref={this.formRef}
                onCancel={this.hideForm}
                onSubmit={this.handleSubmit}
                submitting={submitting}
                visible={visibleForm}
              />
            </Col>
          </Row>
        </div>
      </Fragment>
    );
  }
}

export default connect(null, (dispatch) => {
  return {
    onSetRoute: (data) => dispatch(SetRoute(data)),
  };
})(AppDownloadManagement);
